import { Pipe, PipeTransform } from '@angular/core';
import { StatusWezwania } from '@interfaces/wnioski/enums/sprawy/sprawy-studentow/wezwania/status-wezwania.enum';

@Pipe({
  name: 'statusWezwania',
})
export class StatusWezwaniaPipe implements PipeTransform {
  transform(value: StatusWezwania): string {
    const { Nowe, Zweryfikowano, PrzekazanoDoPodpisu } = StatusWezwania;

    switch (value) {
      case Nowe:
        return 'bg-warning text-secondary';
      case Zweryfikowano:
      case PrzekazanoDoPodpisu:
        return 'bg-success';
      default:
        return 'bg-info';
    }
  }
}
